import React from 'react';
//import { MarkerClustererF } from '@react-google-maps/api';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { useGoogleMap } from '@react-google-maps/api';
import PropTypes from 'prop-types';
import FielderMarker from './FielderMarker';
import Markers from './Markers';

/*const options = {
	imageExtension: 'png',
	imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
};*/
const MAX_ZOOM = 8;
const MINIMAL_CLUSTER_SIZE = 3;
const PinCluster = ({ marker, markers, enableAnimation }) => {
  const map = useGoogleMap();
  const clusterer = React.useMemo(
    () =>
      map
        ? new MarkerClusterer({
          map,
          maxZoom: MAX_ZOOM,
          minimumClusterSize: MINIMAL_CLUSTER_SIZE,
        })
        : null,
    [map]
  );

  return (
    <>
      {markers && markers.length > 0 && clusterer && (
        <Markers markers={markers} clusterer={clusterer} enableAnimation={enableAnimation} />
      )}
      {marker && clusterer && <FielderMarker {...marker} clusterer={clusterer} enableAnimation={enableAnimation} />}
    </>
  );
};

PinCluster.propTypes = {
  marker: PropTypes.object,
  markers: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  enableAnimation: PropTypes.bool,
};
/*const PinCluster = ({ marker, markers, enableAnimation }) => (
  <MarkerClustererF options={options} maxZoom={MAX_ZOOM} minimumClusterSize={MINIMAL_CLUSTER_SIZE} onClick={null}>
    {(clusterer) => (
      <>
        {markers && markers.length > 0 && (
          <Markers markers={markers} clusterer={clusterer} enableAnimation={enableAnimation} />
        )}
        {marker && <FielderMarker {...marker} clusterer={clusterer} enableAnimation={enableAnimation} />}
      </>
    )}
  </MarkerClustererF>
);
PinCluster.propTypes = {
  marker: PropTypes.object,
  markers: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  enableAnimation: PropTypes.bool,
  children: PropTypes.node,
};*/
export default React.memo(PinCluster);
